import { createGlobalStyle } from "styled-components";
import fontUrl from "../fonts/MaterialSymbolsRounded-VariableFont_FILL,GRAD,opsz,wght.ttf";

export const GlobalStyle = createGlobalStyle`

    @font-face {
        font-family: "Material Symbols Rounded";
        src: url(${fontUrl}) format("truetype");
    }

    *, *::before, *::after
    {
        box-sizing: border-box;
        font-family: 'Inter', 'Sans-serif';
        padding: 0;
        margin: 0;
        
    }

    .hiddenScrollbar
    {
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;

        &::-webkit-scrollbar
        {
            display: none !important;
        }
    }

    body
    {
        background: ${ ( { theme } ) => theme.colors.neutralPrimaryBackground };
        font-size: ${({theme}) => theme.fontSize.md};
        height: 100vh;
        width: 100vw;

        div#root
        {
            height: 100%;
            width: 100%;
        }

        div#modalRoot
        {
            position: absolute;
            z-index: 3000;
            top: 0;
            left: 0;
            height: 0%;
            width: 0%;
            display: flex;
            align-items: center;
            justify-content: center;
            
            &:has( > *)
            {
                height: 100%;
                width: 100%;
            }
        }
    }

    svg
    {
        //fill: ${ ( { theme } ) => theme.colors.neutralSecondaryForeground };
    }

    .recharts-wrapper *:focus
    {
        outline: none;
    }

    .recharts-wrapper *:focus-visible
    {
        outline: none;
    }

    .material-icon {
        font-family: "Material Symbols Rounded";
        font-style: normal;
        line-height: 1;
        display: inline-block;
        white-space: nowrap;
    }

    // #region tiptap components

    .tiptap
    {
        width: 100%;
        height: 100%;
        padding: 0 20px;
        flex: 1 1 auto;
        overflow: auto;
        outline: none;
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;

        table
        {
            border-collapse: collapse;
            table-layout: fixed;

            td, th
            {
                padding: ${({theme}) => theme.spacing.xs};
                border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
                position: relative;
            }

            .selectedCell
            {
                background: rgba(${({theme}) => theme.colors.neutralPrimaryBorderRGB}, 0.25);
            }
        }

        .column-resize-handle
        {
            background: ${({theme}) => theme.colors.accentBackground};
            bottom: -2px;
            pointer-events: none;
            position: absolute;
            right: -2px;
            top: 0;
            width: 5px;
        }

        div.tableWrapper
        {
            overflow-x: auto;
            width: 100%;
        }

        &.resize-cursor {
            cursor: ew-resize;
            cursor: col-resize;
        }

        &::-webkit-scrollbar
        {
            display: none !important;
        }

        ul, ol, li
        {
            
            padding-left: 10px;
            margin-left: 10px;
        }

        p
        {
            margin: ${({theme}) => theme.spacing.sm} 0;
        }

        h1, h2, h3, h4
        {
            margin: ${({theme}) => theme.spacing.md} 0;
        }
    }

    .drag-handle
    {
        transition-duration: 220ms;
    }


    .tableCellUI {
        position: fixed;
        pointer-events: none;
        z-index: 1000;
    }

    &:has(table .column-resize-handle)
    {
        .tableCellUI
        {
            display: none;

            .zone
            {
                display: none;
            }
        }
    }

    .tableCellUI .zone {
        position: absolute;
        pointer-events: auto;
        border-radius: ${({theme}) => theme.cornerRadius.sm};
        
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: ${({theme}) => theme.fontSize.sm};
        color: rgba(${({theme}) => theme.colors.mutedForegroundRGB}, 0.25);
        transition-duration: 110ms;

        &.top, &.bottom, &.left, &.right
        {
            background: rgba(${({theme}) => theme.colors.accentBackgroundRGB}, 0.15);

            &:hover
            {
                background: ${({theme}) => theme.colors.accentBackground};
            }
        }

        &.colDelete, &.rowDelete
        {
            background: rgba(${({theme}) => theme.colors.errorBackgroundRGB}, 0.15);

            &:hover
            {
                background: ${({theme}) => theme.colors.errorBackground};
            }
        }

        &:hover
        {
            color: rgba(${({theme}) => theme.colors.mutedForegroundRGB}, 0.75);
        }
    }


    // #endregion
`